import { stringify } from 'query-string';
import formatCalendarDate from '../formatCalendarDate';
import formatCalendarDuration from '../formatCalendarDuration';

export const YAHOO_CALENDAR_URL = 'https://calendar.yahoo.com';

// See https://github.com/InteractionDesignFoundation/add-event-to-calendar-docs/blob/master/services/yahoo.md
const createYahooCalendarLink = ({ startDate, endDate, location, title, description }) => {
  const query = stringify({
    v: '60',
    view: 'd',
    type: '20',
    title,
    st: formatCalendarDate(startDate),
    dur: formatCalendarDuration(endDate, startDate),
    desc: description,
    in_loc: location,
  });

  return `${YAHOO_CALENDAR_URL}?${query}`;
};

export default createYahooCalendarLink;
